import { App } from "./App";

export class FSApp extends App {
}
